import { Axios } from "@/utils/plugin/axios-plugin"
import TokenCache from "@/utils/cache/TokenCache";
import ProInfoCache from "@/utils/cache/ProInfoCache";
import * as signalR from "@aspnet/signalr";

let permissions = []
let inited = false
let connected = false

let OperatorCache = {
  info: {},
  pros: [],
  connection: {},
  inited () {
    return inited
  },
  init (callBack) {
    if (inited)
      callBack()
    else {
      Axios.post('/BaseManage/Home/GetOperatorProsInfo').then(resJson => {
        if (!resJson.Success) {
          console.log(resJson.Message, "danger")
          return
        }
        if (resJson.Data == null) {
          window.$message.error("获取用户信息失败", "danger")
          return
        }
        if (resJson.Data.UserInfo == null) {
          window.$message.error("获取用户信息失败", "danger")
          return
        }
        if (resJson.Data.Pro == null) {
          window.$message.error("获取用户信息失败", "danger")
          return
        }
        this.info = resJson.Data.UserInfo
        this.pros = resJson.Data.Pros
        ProInfoCache.setPros(this.pros)
        let pro = ProInfoCache.getProInfo()
        if ((pro == null || !pro) && this.pros.length > 0) {
          ProInfoCache.setProInfo(resJson.Data.Pro)
        }
        if (pro && this.pros.filter((x) => x.Id == pro.Id).length <= 0) {
          ProInfoCache.setProInfo(resJson.Data.Pro)
        }
        let proInfo = ProInfoCache.getProInfo()
        if (proInfo == null || proInfo.Config == null || !proInfo.Config.Screen) {
          window.$message.error("请联系管理人员开启大屏!");
          TokenCache.deleteToken();
          ProInfoCache.deleteProInfo();
          ProInfoCache.deletePros();
          OperatorCache.clear();
        }

        permissions = resJson.Data.Permissions
        inited = true
        callBack()
      })
    }
  },
  async refreshToken () {
    if (TokenCache.getRefreshToken())
      await Axios.post('/BaseManage/Home/RefreshToken', {
        Token: TokenCache.getRefreshToken()
      }).then(response => {
        if (response.Success) {
          TokenCache.setToken(response.Data);
        }
      })
  },
  loadChooseProInfo (proId) {
    Axios.post('/BaseManage/Home/GetOperatorProInfo', { ProId: proId }).then(resOperatorPro => {
      if (resOperatorPro.Success) {
        ProInfoCache.setProInfo(resOperatorPro.Data)
      }
    })
  },

  getConnect () {
    if (connected) {
      return this.connection;
    }
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl("/bigScreenHub", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .configureLogging(signalR.LogLevel.Information)
      .build();

    if (this.connection) {
      this.connection
        .start()
        .then(() => {
          this.connection.invoke(
            "initializeAsync",
            TokenCache.getToken()
          );
        })
        .catch((err) => console.log(err));

      this.connection.on("connected", () => {
        console.log("Connected.", "primary");
      });

      this.connection.on("disconnected", () => {
        console.log("Disconnected, invalid token.", "danger");
      });
      connected = true
    }
    else {
      console.log("Disconnected.", "danger");
    }
    return this.connection
  },
  hasPermission (thePermission) {
    return permissions.includes(thePermission)
  },
  clear () {
    inited = false
    permissions = []
    this.info = {}
  }
}

export default OperatorCache